import NewsDestaques from "./NewsDestaques";
import UniqueNews from "./UniqueNews";
import styles from "../../../styles/module/news-unique.module.css";

export default function NewsContainer({ idNews }) {
  return (
    <div className={styles.news_container}>
      <UniqueNews idNoticia={idNews} />
      <NewsDestaques excludeId={idNews} />
    </div>
  );
}